module.exports = __webpack_public_path__ + "img/credit-card-secure-1.70fe1e4d.png";